import { boolean, nullable, object, timestamp } from "../../../types/_types";

import { UserRef } from "../../users/types/User";

export const termination = () =>
	object({
		status: boolean(false),
		timestamp: nullable(timestamp()),
		user: nullable(UserRef),
	}).default({
		status: false,
		timestamp: null,
		user: null,
	});
